












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class StatusChip extends Vue {
  @Prop({ type: String, default: 'grey' }) color!: string
  @Prop({ type: String, default: '' }) label!: string
}
